import { TableCell, TableRow, useTheme } from "@mui/material";
import { getDerivativeStatusOptions, getEventPricingStatusOptions, getPricingPhaseOptions, getSuspendedStatusOptions } from "../../../shared/options";
import { useLocation, useNavigate } from "react-router-dom";
import { scheduleRoutes } from "../../ScheduleNavigation";
import { rdsMeeting_Dto } from "../../../../interfaces/dtos/rdsMeeting";
import { rdsEvent_Dto } from "../../../../interfaces/dtos/rdsEvent";
import { useAppSelector } from "../../../../redux/hooks";
import { scheduleState } from "../../../../redux/schedule/scheduleSlice";
import { rdsState } from "../../../../redux/rds/rdsSlice";
import dayjs from "dayjs";
import { eventStatusCodes, eventStatusDesc } from "../../../shared/commonConstants";

export interface ScheduleEventsItemProps {
  meeting: rdsMeeting_Dto;
  event: rdsEvent_Dto;
}

export const ScheduleEventsItem = ({
  meeting, event
}: ScheduleEventsItemProps) => {

  const theme = useTheme();
  const rds = useAppSelector(rdsState);
  const schedule = useAppSelector(scheduleState);
  const navigate = useNavigate();
  const location = useLocation();

  if (!meeting) { return <></> }

  const scheduleEvent = schedule.scheduleEvents.find((se) => se.eventId === event.id);

  const pricingStatusOptions = getEventPricingStatusOptions(theme);
  const pricingStatusOption = pricingStatusOptions.find((o) => o.value === scheduleEvent?.pricingStatusCode);
  // TODO: non MVP for now
  // const pricingStatusDescription = scheduleEvent?.pricingStatusCode ?
  //   pricingStatusOption ? pricingStatusOption.description : `${scheduleEvent?.pricingStatusCode} [Invalid Code]` :
  //   ''

  const pricingPhaseOptions = getPricingPhaseOptions(theme);
  // const pricingPhaseOption = pricingPhaseOptions.find((o) => o.value === event.pricingPhase);
  const pricingPhaseOption = pricingPhaseOptions.find((o) => o.value === '');
  // const pricingPhaseDescription = event.pricingPhase ?
  //   pricingPhaseOption ? pricingPhaseOption.description : `${event.pricingPhase} [Invalid Code]` :
  //   ''
  const pricingPhaseDescription = '';

  const suspendedStatusOptions = getSuspendedStatusOptions(theme);
  // const suspendedStatusOption = suspendedStatusOptions.find((o) => o.value === event.suspentionStatus);
  const suspendedStatusOption = suspendedStatusOptions.find((o) => o.value === '');
  // const suspendedStatusDescription = event.suspentionStatus ?
  //   suspendedStatusOption ? suspendedStatusOption.description : `${event.suspentionStatus} [Invalid Code]` :
  //   ''
  const suspendedStatusDescription = '';

  const derivativeStatusOptions = getDerivativeStatusOptions(theme);
  // const derivativeStatusOption = derivativeStatusOptions.find((o) => o.value === event.derivativesStatus);
  const derivativeStatusOption = derivativeStatusOptions.find((o) => o.value === '');
  // const derivativeStatusDescription = event.derivativesStatus ?
  //   derivativeStatusOption ? derivativeStatusOption.description : `${event.derivativesStatus} [Invalid Code]` :
  //   ''
  const derivativeStatusDescription = '';

  const track = rds.rdsTracks.find((t) => t.id === meeting.trackId);
  const country = track ? track.country : '';

  const handleRowClick = () => {
    navigate(`${scheduleRoutes.root}/${scheduleRoutes.win}${event.id}${location.search}`);
  }

  const eventStatus = rds.rdsEventStatuses.find(es => es.id === event.id);

  const warningBroadcastStatuses = [eventStatusCodes.Void, eventStatusCodes.Abandon];
  const hasWarningBroadcast = warningBroadcastStatuses.includes(eventStatus?.status ?? '') ||
    warningBroadcastStatuses.includes(meeting?.status ?? '');

  const getStatusDesc = () => {
    if (warningBroadcastStatuses.includes(eventStatus?.status ?? '')) {
      return `Event ${eventStatusDesc(eventStatus?.status ?? '').toLowerCase()}`;
    } else if (warningBroadcastStatuses.includes(meeting?.status ?? '')) {
      return `Meeting ${eventStatusDesc(meeting?.status ?? '').toLowerCase()}`;
    } else {
      return eventStatus?.progressMessage;
    }
  }

  return (
    <TableRow
      id={`schedule-event-${event.id}`}
      hover
      sx={{ cursor: 'pointer' }}
      onClick={handleRowClick}
    >
      <TableCell>{meeting.categoryCode}</TableCell>
      <TableCell>{meeting.description}</TableCell>
      <TableCell>{dayjs(event?.dateTime).format("HH:mm")}</TableCell>
      <TableCell>{event.number}</TableCell>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{event.name}</TableCell>
      <TableCell>{country}</TableCell>
      <TableCell sx={{
        whiteSpace: 'nowrap',
        color: hasWarningBroadcast ? theme.palette.error.main : undefined
      }}>
        {getStatusDesc()}
      </TableCell>
      <TableCell sx={{ color: pricingStatusOption?.colour }}>
        {/* // TODO: Non MVP for now */}
        {/* {pricingStatusDescription} */}
      </TableCell>
      <TableCell sx={{ color: pricingPhaseOption?.colour }}>
        {pricingPhaseDescription}
      </TableCell>
      <TableCell sx={{ color: suspendedStatusOption?.colour }}>
        {suspendedStatusDescription}
      </TableCell>
      <TableCell sx={{ color: derivativeStatusOption?.colour }}>
        {derivativeStatusDescription}
      </TableCell>
      <TableCell></TableCell>
    </TableRow>
  )
}
